import { FC } from 'react'
import { FirmDetailsQuoteData, FirmDetailsQuoteLimit } from 'src/dtos/portal'
import {
  FirmViewSectionContainer,
  FlexDiv,
  OrangeButton,
} from '../index'
import { HiOutlineCalendar } from 'react-icons/hi'
import { numberToCurrency, numberToSimple } from 'src/utils/numberFormat'
import { format } from 'date-fns'
import { QuoteLimitsTable } from 'src/components/application/defaultComponents'
import { ascendingSorter } from 'src/utils/array'
interface FirmViewQuoteProps {
  firmDetailsQuote?: FirmDetailsQuoteData;
  firmId?: number;
}

const FirmViewQuote: FC<FirmViewQuoteProps> = ({ firmDetailsQuote, firmId }) => {
  function handleViewPDFClick() {
    const url = `/api/Firm/quotedocument/${firmId}`;
    return window.open(url);
  }

  return (
      <FirmViewSectionContainer>
        <FlexDiv align='center' justify='space-between'>
          <h1 style={{ color: '#937251' }}>
          {firmDetailsQuote?.quoteType.toUpperCase() === 'BASIC'
                ? 'Essential'
                : firmDetailsQuote?.quoteType.toUpperCase() === 'REGULAR'
                  ? 'Premiere'
                  : firmDetailsQuote?.quoteType} POLICY
          </h1>
          <OrangeButton
            onClick={handleViewPDFClick} 
          >View Quote (PDF)</OrangeButton>
        </FlexDiv>
        {firmDetailsQuote ? (
          <>
            { firmDetailsQuote.policyFound && (firmDetailsQuote.paymentsInFull || firmDetailsQuote.subSequentPayment) ? (
              <FlexDiv dir='column' margin='32px 0 0'>
                <h5>PAYMENTS</h5>
                <hr style={{ marginTop: '8px' }} />
                <FlexDiv margin="24px 0 0 0">
                  { firmDetailsQuote.policyFound && firmDetailsQuote.paymentsInFull && firmDetailsQuote.paymentsInFull > 0 ? (
                    <FlexDiv dir='column' gap="22px">
                      <article>
                        <h5>If Paid In Full</h5>
                        <h2>{numberToCurrency(firmDetailsQuote.paymentsInFull)}</h2>
                      </article>
                    </FlexDiv>
                  ): null }
                  { firmDetailsQuote.policyFound && firmDetailsQuote.subSequentPayment && firmDetailsQuote.subSequentPayment > 0 ? (
                    <FlexDiv dir='column'>
                      <article>
                        <h5>Monthly Payment (x7)</h5>
                        <h2>{numberToCurrency(firmDetailsQuote.subSequentPayment)}</h2>
                      </article>
                    </FlexDiv>
                  ): null }
                </FlexDiv>
              </FlexDiv>
            ): null}

          <FlexDiv dir="column" margin='48px 0 0 0'>
            <h5>POLICY DETAILS</h5>
            <hr style={{ marginTop: '8px' }} />
            <QuoteLimitsTable>
              <thead>
                <tr>
                <th>Per Claim Limit</th>
                <th>Aggregate Limit</th>
                <th>Aggregate Deductible</th>
                </tr>
              </thead>
              <tbody>
              {firmDetailsQuote.limits
                .sort(ascendingSorter((limit: FirmDetailsQuoteLimit) => limit.perClaimLimit))
                .map((limit,idx) => (
                  <tr key={`limits-table-row-${idx}`} >
                    <td>
                        {numberToSimple(limit.perClaimLimit, 2)}
                    </td>
                    <td>
                        {numberToSimple(limit.aggregateLimit, 2)}
                    </td>
                    <td>
                        {numberToSimple(limit.aggregateDeductible, 2)}
                    </td>
                  </tr>
                ))
              }
              </tbody>
            </QuoteLimitsTable>
          </FlexDiv>
          <FlexDiv dir="column" margin='48px 0 0 0'>
            <h5>IMPORTANT DATES</h5>
            <hr style={{ marginTop: '8px' }} />
            <FlexDiv margin="24px 0 0 0">
              <FlexDiv gap="22px" align='center'>
                <h5>
                  <HiOutlineCalendar />
                  This Quote Expires
                </h5>
                <h6>{format(new Date(firmDetailsQuote.quoteExpiryDate), 'MM/dd/yyyy')}</h6>
              </FlexDiv>
            </FlexDiv>
          </FlexDiv>
          </>
        ) : (
          <h3 style={{  marginTop: '64px' }}>Loading...</h3>
        )}
      </FirmViewSectionContainer>
  )
}

export default FirmViewQuote